import Script from 'next/script';

export const GooglePlaceScript = ({
  nonce,
  googleApiKey,
}: {
  nonce: string;
  googleApiKey: string;
}): JSX.Element => {
  return (
    <Script
      strategy="lazyOnload"
      src={`https://maps.googleapis.com/maps/api/js?v=beta&key=${googleApiKey}&libraries=places`}
      nonce={nonce}
      onLoad={() => {
        const googlePlaceLoadedEvent = new CustomEvent('googlePlaceLoaded');
        window.dispatchEvent(googlePlaceLoadedEvent);
      }}
    />
  );
};
